import { render } from "./GuardianSelectionModal.vue?vue&type=template&id=130c2998&scoped=true"
import script from "./GuardianSelectionModal.vue?vue&type=script&lang=js"
export * from "./GuardianSelectionModal.vue?vue&type=script&lang=js"

import "./GuardianSelectionModal.vue?vue&type=style&index=0&id=130c2998&lang=css"
import "./GuardianSelectionModal.vue?vue&type=style&index=1&id=130c2998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130c2998"]])

export default __exports__